/**
 * GFG's gift taxonomy — exactly the choices of the Shopify `custom.gift_category` metafield, in
 * GFG's order (GFG-372). The Category filter offers these values verbatim (no mapping), and only the
 * ones that at least one product in the current view carries. A product may hold up to 2.
 * "Charity Gifts" and "Experiences" are also offered when a product's type implies them, even if
 * untagged (see utils/redemption-helper.ts).
 */
export const GIFT_CATEGORIES = [
  "Gift Boxes & Sets",
  "Home & Living",
  "Accessories & Apparel",
  "Jewelry",
  "Bags & Wallets",
  "Tech & Office",
  "Candles & Self-Care",
  "Food & Drink",
  "Experiences",
  "Charity Gifts",
] as const;

/**
 * The 6 official causes, as defined by the choices of the Shopify `impact.primary` metafield
 * definition. A product's own primary cause is read from `impact.cause` (free text) and its
 * secondary ones from `impact.secondary_vendor`, which mix these 6 with finer tags ("Mental
 * Health", "Artisans"); the Cause filter offers only the official 6 (confirmed by Will, GFG-334).
 */
export const OFFICIAL_CAUSES = [
  "Care for Children",
  "Empower Women",
  "Improve Human Health",
  "Protect the Environment",
  "Save Animals",
  "Support Job Creation",
] as const;
